export { default } from './EnergiaSolarParceiros';
